var comparator = {

    '<': function (a, b) {
        return a < b;
    },

    '<=': function (a, b) {
        return a <= b;
    },

    '>': function (a, b) {
        return a > b;
    },

    '>=': function (a, b) {
        return a >= b;
    }

}

module.exports = function (version, range) {
    var string = (range + '');

    var n = +(string.match(/\d+/) || NaN);

    var op = string.match(/^[<>]=?|/)[0];

    return comparator[op] ? comparator[op](version, n) : (version == n || n !== n);
};